import { nameBrand } from '~/util/defaultInfo'

export default {
  bonusList: {
    path: '/promotions',
    title: {
      ru: 'Акции',
      ua: 'Акції',
    },
  },
  welcomePack: {
    path: '/promotions/welcome-pack',
    title: {
      ru: 'Приветственный пакет',
      ua: 'Вітальний пакет',
    },
  },
}
